var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var DownloadAltIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 64,
    glyphHeight: 64
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.39876e-06 32C-1.40606e-06 31.833 0.0012649 31.6663 0.00378567 31.5L5.60469 31.5C5.60157 31.6663 5.6 31.833 5.6 32C5.6 46.5333 17.4667 58.4 32 58.4C46.5334 58.4 58.4 46.5333 58.4 32C58.4 31.833 58.3985 31.6663 58.3953 31.5L63.9962 31.5C63.9988 31.6663 64 31.833 64 32C64 49.7333 49.7334 64 32 64C14.2667 64 -6.23616e-07 49.7333 -1.39876e-06 32ZM33.4388 43.2189L45.8515 30.807C46.8929 29.7656 46.8929 28.0772 45.8515 27.0358C44.8101 25.9944 43.1216 25.9944 42.0802 27.0358L34.2199 34.8954L34.2199 -2.15865e-05L28.8866 -2.13533e-05L28.8866 34.8954L21.0269 27.0358C19.9855 25.9944 18.2971 25.9944 17.2557 27.0358C16.2143 28.0772 16.2143 29.7656 17.2557 30.807L29.6676 43.2189C30.709 44.2603 32.3975 44.2603 33.4388 43.2189Z"
  }));
};
export var DownloadAltIconGlyph = function (props) {
  return React.createElement(DownloadAltIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};